module.exports = __webpack_public_path__ + "img/37.2.TN.36a5d60d.png";